"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SurveyFactory = void 0;
var srs_1 = require("../srs");
var language_1 = require("../language");
var utils_1 = require("../utils");
var authGroup_1 = require("../auth/authGroup");
var defaultParams = {
    languages: [language_1.LanguageCode.en],
    published: false,
    draft: true,
    template: false,
    authGroups: authGroup_1.DEFAULT_AUTH_GROUPS
};
exports.SurveyFactory = {
    createInstance: function (params) {
        var _a;
        var _b = __assign(__assign({}, defaultParams), params), ownerUuid = _b.ownerUuid, name = _b.name, label = _b.label, languages = _b.languages, published = _b.published, draft = _b.draft, collectUri = _b.collectUri, descriptions = _b.descriptions, authGroups = _b.authGroups, template = _b.template;
        return {
            id: undefined,
            uuid: utils_1.UUIDs.v4(),
            published: published,
            draft: draft,
            ownerUuid: ownerUuid,
            authGroups: authGroups,
            props: {
                name: name,
                languages: languages,
                labels: label ? (_a = {}, _a[languages[0]] = label, _a) : {},
                srs: [srs_1.DEFAULT_SRS],
                cycles: {
                    '0': {
                        dateStart: new Date().toISOString().split('T')[0]
                    }
                },
                descriptions: descriptions,
                collectUri: collectUri
            },
            template: template
        };
    }
};
//# sourceMappingURL=factory.js.map